<div class="content-block">
    <div class="row">
    <h4>Scegli la matricola dalla lista sottostante</h4>
    </div>
    <div class="row">
        <dx-lookup displayExpr="matricola" valueExpr="id" [dataSource]="listMatricole"
                [searchEnabled]="true" [(value)]="idMatricola">
              </dx-lookup>
    </div>
    <div class="row div-button">
        <dx-button stylingMode="contained" type="danger" text="Annulla" (onClick)="onAnnullaMatricola()" width="150">
        </dx-button>

        <dx-button stylingMode="contained" type="success" text="Conferma" (onClick)="onScegliMatricola()" width="150">
        </dx-button>
    </div>
</div>